import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enLegal from './locales/en/legal.json';
import enAuth from './locales/en/auth.json';
import enBusinessAdmin from './locales/en/businessAdmin.json';
import enMarketplaceAdmin from './locales/en/marketplaceAdmin.json';
import enFraudAdmin from './locales/en/fraudAdmin.json';
import kmCommon from './locales/km/common.json';
import kmHome from './locales/km/home.json';
import kmLegal from './locales/km/legal.json';
import kmAuth from './locales/km/auth.json';
import kmBusinessAdmin from './locales/km/businessAdmin.json';
import kmMarketplaceAdmin from './locales/km/marketplaceAdmin.json';
import kmFraudAdmin from './locales/km/fraudAdmin.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        legal: enLegal,
        auth: enAuth,
        businessAdmin: enBusinessAdmin,
        marketplaceAdmin: enMarketplaceAdmin,
        fraudAdmin: enFraudAdmin,
      },
      km: {
        common: kmCommon,
        home: kmHome,
        legal: kmLegal,
        auth: kmAuth,
        businessAdmin: kmBusinessAdmin,
        marketplaceAdmin: kmMarketplaceAdmin,
        fraudAdmin: kmFraudAdmin,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Update html lang attribute on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial lang attribute
document.documentElement.lang = i18n.language;

export default i18n;
